<template>
  <blank-view>
    <div slot="action" style="display: flex; align-items: center; justify-content: space-between">
      <div>
        <a-button v-acl="'page_ops_customer_new_customer'" type="primary" style="margin-right: 8px" @click="handleAdd">
          <a-icon type="plus" />{{ $t('page_ops_customer_new_customer') }}
        </a-button>
        <a-button
          v-acl="'page_ops_customer_build_tenant'"
          :disabled="disableTurnToTenant"
          style="margin-right: 8px"
          @click="handleTurnToTenant"
        >
          {{ $t('page_ops_customer_build_tenant') }}
        </a-button>
        <a-button v-acl="'page_mini_auth'" :disabled="selectedRowKeys.length!==1" style="margin-right: 8px" @click="miniVisible=true">{{$t('page_mini_auth')}}</a-button>
        <a-button v-acl="'page_ops_customer_delete_customer'" style="margin-right: 8px" type="danger" :disabled="selectedRowKeys.length === 0" @click="handleDelete">
          {{ $t('delete') }}
        </a-button>
        <span v-acl="'page_ops_customer_import_customer'">
          <import-button
            filename= '客户模板.xlsx'
            :downloadFn='exportFn'
            :importFn=importFn
            :newResFlag=true
            @refresh="getData"
            style="margin-right: 8px"
          />
        </span>
        <a-button v-acl="'page_ops_customer_export_customer'" @click="exportCustomer">
          {{ $t('export') }}
        </a-button>
      </div>
      <div>
        <a-button style="margin-right: 8px" @click="toggleSearch" class="heightSearch">
          {{ $t('page_my_document_advanced') }}
          <a-icon type="filter" />
        </a-button>
        <a-input-search
          v-model="filter.keywords"
          :placeholder="$t('please_select') + $t('page_ops_customer_keyword')"
          :enterButton="$t('search')"
          allowClear
          style="width: 300px"
          @search="searchData"
        />
      </div>
    </div>
    <div style="display: flex; flex-wrap: nowrap; height: 100%">
      <div id="custom-list" class="custom-list">
        <ml-table
          :columns="columns"
          :dataSource="dataSource"
          :rowSelection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange
          }"
          size="small"
          rowKey="id"
          :pagination="false"
          :selectRowKey="selectedRow && selectedRow.id"
          :scroll="{ y: scrollY }"
          :customRow="
            (row) => ({
              on: {
                click: () => {
                  this.clickRow(row)
                }
              }
            })
          "
        >
          <template slot="name" slot-scope="text, record">
            <div class="customer-table-flex">
              <a-tooltip>
                <template slot="title">
                  {{ $t('page_ops_exist_custom_device') }}
                </template>
                <div class="customer-table-point" v-if="record.customMachine"></div>
              </a-tooltip>
              <a-tag color="blue" v-if="record.relatedTenantId">
                {{ $t('page_ops_customer_tenant') }}
              </a-tag>
              {{ text }}
            </div>
          </template>
        </ml-table>
        <a-pagination
          size="small"
          style="position: absolute; bottom: 8px; right: 8px"
          :show-total="(total) => `${showTotal(total)}`"
          :current="filter.current"
          :pageSize="filter.size"
          :total="total"
          showLessItems
          @change="handleTableChange"
        ></a-pagination>
      </div>
      <div class="custom-detail">
        <customer-detail
          :customer-id="selectedRowId"
          :deviceStatu="deviceStatu"
          :deviceTypes="deviceTypes"
          @toggleCustomer="toggleCustomer"
          class="customer-detail"
        ></customer-detail>
      </div>
    </div>
    <creat-edit-modal
      :codeList="codeList"
      :editItem="editItem"
      :visible="creatVisible"
      @cancel="cancel"
      :loading="loading"
      :isEdit="isEdit"
      @ok="() => ok()"
    ></creat-edit-modal>
    <advance-search
      :visible="advanceVisible"
      :item="filter.advance"
      @close="closeToggleSearch"
      @advanceSearch="startToggleSearch"
    ></advance-search>
    <turn-to-tenant-modal
      ref="turnToTenantModel"
      :visible="turnToTenantModelVisible"
      :formData="customerOfTurnToTenant"
      @close="closeTurnToTenantModel"
    >
    </turn-to-tenant-modal>
    <mini-auth v-model="miniVisible" :customerInfo="selectedRow" />
  </blank-view>
</template>

<script>
import CustomerDetail from './components/CustomerDetail'
import CreatEditModal from './components/CreatEditModal'
import AdvanceSearch from './components/advanceSearch'
import { CustomerServiceProxy } from '@/service-proxies/app-v2/client.service-proxies'
import { CodeRuleServiceProxy } from '@/service-proxies/app-v2/code.service-proxies'
import { DictServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import { DeviceTypeServiceProxy } from '@/service-proxies/app-v2/workStation.service-proxies'
import TurnToTenantModal from './components/TurnToTenantModal.vue'
import { exportCustomer, importCustomer, exportCustomerTemplate } from "@/api/api";
import ImportButton from '@/components/ImportButton/index.vue'
import MiniAuth from './components/MiniAuth'

const dbsp = new DictServiceProxy()
const csp = new CustomerServiceProxy()
const crsp = new CodeRuleServiceProxy()
const dtsp = new DeviceTypeServiceProxy()

export default {
  components: {
    CustomerDetail,
    CreatEditModal,
    AdvanceSearch,
    TurnToTenantModal,
    ImportButton,
    MiniAuth
  },
  watch: {
    '$route.query': {
      handler(v){
        this.filter.keywords = v.keyWord || ''
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    return {
      selectedRow: {}, // 编辑数据
      total: 0,
      creatVisible: false,
      filter: {
        // 查询条件
        size: 20,
        current: 1,
        keywords: '',
        advance: {}
      },
      isAdvance: false,
      columns: [
        {
          title: this.$t('actions'),
          dataIndex: 'action',
          key: 'action',
          width: 50,
          customRender: (_, record) => {
            return (
              <a v-acl={'page_ops_customer_edit_customer'}
                onClick={(e) => {
                  e.stopPropagation()
                  this.edit(record)
                }}
              >
                {this.$t('edit')}
              </a>
            )
          }
        },
        {
          title: this.$t('page_ops_customer_customer_name'),
          dataIndex: 'name',
          key: 'name',
          ellipsis: true,
          scopedSlots: { customRender: 'name' }
        }
      ],
      scrollY: 0,
      dataSource: [],
      codeList: [],
      selectedRowKeys: [],
      loading: false,
      editItem: {},
      isEdit: false, // 是否是编辑
      advanceVisible: false,
      deviceStatu: [], //设备状态列表
      deviceTypes: [],
      turnToTenantModelVisible: false,
      customerOfTurnToTenant: {},
      disableTurnToTenant: true,
      selectedRowId: '',
      importFn: importCustomer,
      exportFn: exportCustomerTemplate,
      miniVisible: false, // 小程序权限弹框
    }
  },
  async created() {
    const name  = this.$route.query.name;
    console.log('name:', name);
    await this.getDeviceStatus()
    await this.getTypeList()
    await this.getList()
    this.getData()
  },
  methods: {
    toggleCustomer(id) {
      this.selectedRow = this.dataSource.filter(res => res.id === id)[0]
      this.selectedRowId = this.selectedRow.id
      this.selectedRowKeys = [this.selectedRow.id]
    },
    showTotal(total) {
      return this.$t('Total…items').replace('{0}', total)
    },
    handleTableChange(current) {
      this.filter.current = current
      this.getData()
    },
    async getDeviceStatus() {
      const status = await dbsp.list('machine-assembly-state', '')
      this.deviceStatu = [{ key: '0', value: this.$t('page_ops_customer_all_status') }]
      const statusList = status.data[0].children.map((res) => {
        return { key: res.dictKey, value: res.dictValue }
      })
      this.deviceStatu = this.deviceStatu.concat(statusList)
    },
    async getTypeList() {
      const filter = {
        keywords: '',
        query: {
          current: 1,
          size: -1
        }
      }
      const type = await dtsp.pageDeviceType(filter)
      this.deviceTypes = [{ key: 0, value: this.$t('page_ops_customer_all_types') }]
      const list = type.records.map((res) => {
        return { key: res.id, value: res.name }
      })
      this.deviceTypes = this.deviceTypes.concat(list)
    },
    handleAdd() {
      this.isEdit = false
      this.editItem = {}
      this.creatVisible = true
    },
    handleBuild() {
      this.buildVisible = true
    },
    cancel() {
      this.creatVisible = false
    },
    clickRow(row) {
      this.selectedRow = row
      this.selectedRowId = row.id
      this.selectedRowKeys = [row.id]
      this.refreshTurnTenantButtonState()
    },
    handleDelete() {
      this.$confirm({
        title: this.$t('page_ops_customer_delete_customer'),
        content: ()=>{
          const isExitCustomDevice = this.isOnlyExitCustomerList();
          if(isExitCustomDevice) {
            return <div>
              <div style="font-weight: bold;margin-bottom: 10px;margin-left: 30px;">{this.$t('page_work_is_exist_custom_device')}</div>
              <div>
                { this.$t('page_ops_customer_delete_it_tip') + '?' }
              </div>
            </div>
          } else {
            return <div>
              <div>
                { this.$t('page_ops_customer_delete_it_tip') + '?' }
              </div>
            </div>
          }
        },
        okText: this.$t('delete'),
        okType: 'danger',
        cancelText: this.$t('cancel'),
        icon: () => <a-icon style="color: #ff0000" type="exclamation-circle" />,
        onOk: () => {
          this.readyDelete()
        }
      })
    },
    isOnlyExitCustomerList() {
      return this.dataSource.some(v=>{
        for(let i = 0; i<this.selectedRowKeys.length; i++) {
          const id = this.selectedRowKeys[i];
          if(v.id===id && v.customMachine) {
            return true;
          } else {
            return false
          }
        }
      });
    },
    async readyDelete() {
      const ids = this.selectedRowKeys
      await csp.deleteSupplier(ids)
      this.$message.success(this.$t('page_ops_customer_delete_success'))
      this.selectedRow = {}
      this.selectedRowKeys = []
      this.selectedRowId = ''
      this.filter.current = 1
      this.getData()
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
      this.refreshTurnTenantButtonState()
    },
    refreshTurnTenantButtonState() {
      this.disableTurnToTenant = !!(
        this.selectedRowKeys.length !== 1 || this.selectedRow.relatedTenantId
      )
    },
    async ok() {
      this.creatVisible = false
      this.filter.current = 1
      this.getData()
    },
    toggleSearch() {
      this.advanceVisible = !this.advanceVisible
    },
    closeToggleSearch() {
      this.advanceVisible = false
    },
    startToggleSearch(value) {
      this.filter.keywords = ''
      this.filter.advance = value
      this.selectedRowId = ''
      this.selectedRow = {}
      this.selectedRowKeys = []
      this.filter.current = 1
      this.getData()
    },
    searchData() {
      this.filter.advance = {}
      this.selectedRowId = ''
      this.selectedRow = {}
      this.selectedRowKeys = []
      this.filter.current = 1
      this.getData()
    },
    async edit(value) {
      const item = await csp.getCustomer(value.id)
      this.editItem = item
      this.isEdit = true
      this.creatVisible = true
    },
    async getData() {
      this.selectedRowId = ''
      this.dataSource = []
      let data = {}
      if (this.filter.keywords) {
        this.filter.advance = {}
        this.isAdvance = false
        data = await this.getKeyword()
      } else {
        this.isAdvance = true
        data = await this.getAdvance()
      }
      if (data.records) {
        this.total = data.total
        this.dataSource = data.records
        if (JSON.stringify(this.selectedRow) === '{}') {
          this.selectedRow = this.dataSource[0]
          this.selectedRowId = this.dataSource[0].id
          this.selectedRowKeys = [this.dataSource[0].id]
        } else {
          this.selectedRowId = this.selectedRow.id
          this.selectedRowKeys = [this.selectedRow.id]
        }

        const dev = document.getElementById('custom-list')
        if (dev) {
          const height = dev.clientHeight - 80
          if (height < data.records.length * 33) {
            this.scrollY = height
          } else {
            this.scrollY = 0
          }
        }
        this.refreshTurnTenantButtonState()
      }
    },
    async getKeyword() {
      return await csp.getPageCustomer(undefined,this.filter.current, this.filter.keywords, this.filter.size)
    },
    async getAdvance() {
      const advance = this.filter.advance
      return await csp.getPageCustomerByCondition(this.filter.current, advance, this.filter.size)
    },
    async getList() {
      let result = await crsp.list('CustomerObject')
      this.codeList = result.map((item) => ({
        label: item.name,
        value: item.id
      }))
    },
    async handleTurnToTenant() {
      this.turnToTenantModelVisible = true
      const item = await csp.getCustomer(this.selectedRow.id)
      this.customerOfTurnToTenant = item
    },
    async closeTurnToTenantModel(flag) {
      this.turnToTenantModelVisible = false
      if (flag) {
        this.filter.current = 1
        await this.getData()
        this.disableTurnToTenant = true
      }
    },
    exportCustomer() {
      const params = {idList: this.selectedRowKeys,keyWord: this.filter.keywords, host: window.location.host, isAdvance: this.isAdvance}
      exportCustomer({...this.filter.advance, ...params}).then((res) => {
        // 创建隐藏的可下载链接
        var a = document.createElement("a")
        a.download = `${this.$t('page_ops_customers')}.xlsx`
        a.style.display = "none"
        // 字符内容转变成blob地址
        let url = URL.createObjectURL(res)
        a.href = url
        // 触发点击
        document.body.appendChild(a)
        a.click()
        // 然后移除
        URL.revokeObjectURL(url)
        document.body.removeChild(a)
      });
    },
  }
}
</script>

<style lang="less" scoped>
.exception {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: #f0f2f5;
  padding-bottom: 240px;
  .text {
    padding: 24px;
    p {
      font-size: 20px;
    }
  }
}
.custom-list {
  width: 400px;
  position: relative;
}
.custom-detail {
  width: calc(100% - 400px);
  border-left: 1px solid #d7d7d7;
  height: 100%;
  overflow: hidden;
}
.customer-table-flex {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.customer-table-point {
  background-color: #faad14;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 6px;
}
</style>
